import React from 'react';
import CountrySelect from '../components/CountrySelect';
import { validStates } from './PatientInfoForm';
import InternationalAddressInputForm from './InternationalAddressInputForm';
import GoogleAddressInputForm from "./GoogleAddressInputForm";

/**
 * The patient shipping address form.
 * The form will switch to International mode when the requisition layout is not domestic or if 
 *  the selected country is not United States.
 * 
 * @param props.onChangeHandlers An object containing the onChange functions for each field.
 */
export default function AddressInputForm({
	covidRegistration,
	disabled,
	fullRegistrationRequired,
	form,
	isInternational,
	onChangeHandlers,
	physicianInTheLoop,
	handleShippingChange,
	addressLookupEnabled,
	userInfo
}) {

	if (!form) {
		return null;
	}

	// If the requisition is international or a country is selected other than "United States" display the international address form
	if (isInternational || (form.country?.value && form.country.value !== 'United States')) {
		return <InternationalAddressInputForm covidRegistration={covidRegistration}
		disabled={disabled}
		fullRegistrationRequired={fullRegistrationRequired}
		form={form}
		isInternational={isInternational}
		handleShippingChange={handleShippingChange}
		addressLookupEnabled={addressLookupEnabled}
		userInfo={userInfo}
		onChangeHandlers={onChangeHandlers} />
	}

	return (
		<>
			<div className="row">
				<div className={'form-group col-md-6 ' + (form.address1?.valid === false ? 'has-error' : '')}>
					<label className="control-label" htmlFor="patient-address1">
						Address 1{fullRegistrationRequired && <span className="text-danger">*</span>}
					</label>
					{addressLookupEnabled === true ?
						(<GoogleAddressInputForm
							form={form}
							fullRegistrationRequired={fullRegistrationRequired}
							isInternational={isInternational}
							handleShippingChange={handleShippingChange}
							onChangeHandlers={onChangeHandlers}
							userInfo={userInfo}
						/>) :
						<input
							className="form-control"
							name="patientAddress"
							id="patient-address1"
							maxLength="128"
							type="text"
							value={form.address1?.value || ''}
							onChange={onChangeHandlers?.address1}
							autoComplete="new-password"
							disabled={disabled}
						></input>
					}
					{form.address1?.valid === false && (
						<span className="validation-message text-danger">{form.address1?.message}</span>
					)}
				</div>
				<div className={'form-group col-md-6 ' + (form.address2?.valid === false ? 'has-error' : '')}>
					<label className="control-label" htmlFor="patient-address2">
						Address 2
					</label>
					<input
						className="form-control"
						name="patientAddress"
						id="patient-address2"
						maxLength="128"
						type="text"
						value={form.address2?.value || ''}
						onChange={onChangeHandlers?.address2}
						autoComplete="new-password"
						disabled={disabled}
					></input>
					{form.address2?.valid === false && (
						<span className="validation-message text-danger">{form.address2?.message}</span>
					)}
				</div>
			</div>
			<div className="row">
				<div className={'form-group col-md-3 ' + (form.city?.valid === false ? 'has-error' : '')}>
					<label className="control-label" htmlFor="patient-city">
						City
						{fullRegistrationRequired && <span className="text-danger">*</span>}
					</label>
					<input
						className="form-control"
						name="patientAddress"
						id="patient-city"
						maxLength="64"
						type="text"
						value={form.city?.value || ''}
						onChange={onChangeHandlers?.city}
						autoComplete="new-password"
						disabled={disabled}
					></input>
					{form.city?.valid === false && (
						<span className="validation-message text-danger">{form.city?.message}</span>
					)}
				</div>
				<div className={'form-group col-md-1 ' + (form.state?.valid === false ? 'has-error' : '')}>
					<label className="control-label" htmlFor="patient-state">
						State
						{fullRegistrationRequired && <span className="text-danger">*</span>}
					</label>
					<input
						className="form-control"
						name="patientAddress"
						id="patient-state"
						maxLength="2"
						style={{ paddingLeft: '5px', paddingRight: '5px' }}
						type="select"
						list="states"
						pattern={validStates}
						title="Enter a valid 2 character state abbreviaton."
						value={form.state?.value || ''}
						onChange={onChangeHandlers?.state}
						autoComplete="new-password"
						disabled={disabled}
					></input>
					{form.state?.valid === false && (
						<span className="validation-message text-danger">{form.state?.message}</span>
					)}
				</div>
				<div className={'form-group col-md-2 ' + (form.zipCode?.valid === false ? 'has-error' : '')}>
					<label className="control-label" htmlFor="patient-zip">
						Zip
						{fullRegistrationRequired && <span className="text-danger">*</span>}
					</label>
					<input
						className="form-control"
						name="patientAddress"
						id="patient-zipCode"
						maxLength="5"
						type="text"
						value={form.zipCode?.value || ''}
						onChange={onChangeHandlers?.zipCode}
						autoComplete="new-password"
						disabled={disabled}
					></input>
					{form.zipCode?.valid === false && (
						<span className="validation-message text-danger">{form.zipCode?.message}</span>
					)}
				</div>

				<div className={'form-group col-md-3 ' + (form.country?.valid === false ? 'has-error' : '')}>
					<label className="control-label" htmlFor="patient-country">
						Country
						{fullRegistrationRequired && <span className="text-danger">*</span>}
					</label>
					<CountrySelect
						selectedCountry={physicianInTheLoop ? 'United States' : form.country?.value || ''}
						name="patientAddress"
						id="patient-country"
						onChange={onChangeHandlers?.country}
						disabled={physicianInTheLoop}
					/>
					{form.country?.valid === false && (
						<span className="validation-message text-danger">{form.country?.message}</span>
					)}
				</div>
				<div className={'form-group col-md-3 ' + (form.county?.valid === false ? 'has-error' : '')} title="">
					<label className="control-label" htmlFor="patient-county">
						County
						{covidRegistration && <span className="text-danger">*</span>}
					</label>
					<input
						className="form-control"
						name="patientAddress"
						id="patient-county"
						maxLength="64"
						type="text"
						value={form.county?.value || ''}
						onChange={onChangeHandlers.county}
						autoComplete="new-password"
					></input>
					{form.county?.valid === false && (
						<span className="validation-message text-danger">{form.county?.message}</span>
					)}
				</div>
			</div>
		</>
	);
}
